import { useUserShops } from "hooks/firestore/advanced/useUserShops"
import RestaurantTable from "../components/restaurants/RestaurantTable"
import Loader from "../components/utils/Loader"

const Restaurants = () => {
  const restaurants = useUserShops()

  return !restaurants ? <Loader /> : <RestaurantTable shops={restaurants} />
}

export default Restaurants
